import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		api_url: process.env.VUE_APP_API_URL,
		layout: {
			card_class: 'row-cols-1 row-cols-md-2',
			logo: 'https://media.iamconnected.com/images/iac_oc_logo-gold.png',
		},
		show_loading: 0,
		year: null,
	},
	mutations: {},
	computed: {},
	actions: {},
	modules: {},
	getters: {},
});

export default store;
